import "./Footer.css";
import React from "react";
import {Link} from "react-router-dom";
import footerLinks from "../assets/constants/footerLinks.js"
import siteMap from "../assets/constants/siteMap.js"
import aiFreeCommitment from '../assets/images/aiFreeCommitment.png'


function Footer(props) {

  return (
    <div className="footer">
            <footer className="footerContainer">
                <nav>
                  <p className="footerText footerTextSmall"> site map</p>
                        <ul className="navItemList">
                      {siteMap.map((link, index) => (
                        <li><Link className="navItem" to={link.href}>{link.name}</Link></li>
                      )
                      )}
                    </ul>
                  <p className="footerText footerTextSmall"> cierra's links</p>
                  <p className="footerText footerTextSmallest"> currently on a social media hiatus, please reach out via email</p>
                    <ul className="navItemList">
                      {footerLinks.map((link, index) => (
                        <li><a className="navItem" href={link.href}>{link.name}</a></li>
                      )
                      )}
                    </ul>
                </nav>
                <div className="footerBottom">
                    <p className="footerText"> © 2026 Cierra Beck & Cerise Technology LLC </p>
                </div>
                <a href="https://cerise-technology.com/ai-free-commitment" >
                  <img src={aiFreeCommitment} alt="certified generative AI free - click to learn more about our commitment" className="aiFreeCommitmentImage"/>
                </a>
            </footer>
    </div>
  );
}

export default Footer;
